// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file ai_color_simulation/v1/messages.proto (package ai_color_simulation.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file ai_color_simulation/v1/messages.proto.
 */
export const file_ai_color_simulation_v1_messages: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * 座標を表すメッセージ
 *
 * @generated from message ai_color_simulation.v1.Point
 */
export type Point = Message<"ai_color_simulation.v1.Point"> & {
  /**
   * @generated from field: double x = 1;
   */
  x: number;

  /**
   * @generated from field: double y = 2;
   */
  y: number;
};

/**
 * Describes the message ai_color_simulation.v1.Point.
 * Use `create(PointSchema)` to create a new message.
 */
export const PointSchema: GenMessage<Point> = /*@__PURE__*/
  messageDesc(file_ai_color_simulation_v1_messages, 0);

/**
 * ポリゴンを表すメッセージ
 *
 * @generated from message ai_color_simulation.v1.Polygon
 */
export type Polygon = Message<"ai_color_simulation.v1.Polygon"> & {
  /**
   * @generated from field: repeated ai_color_simulation.v1.Point points = 1;
   */
  points: Point[];
};

/**
 * Describes the message ai_color_simulation.v1.Polygon.
 * Use `create(PolygonSchema)` to create a new message.
 */
export const PolygonSchema: GenMessage<Polygon> = /*@__PURE__*/
  messageDesc(file_ai_color_simulation_v1_messages, 1);

/**
 * メインエリアの色情報
 *
 * @generated from message ai_color_simulation.v1.MainAreaColor
 */
export type MainAreaColor = Message<"ai_color_simulation.v1.MainAreaColor"> & {
  /**
   * "outer wall and balcony", "roof, ridge", "gutter", or "fascia, barge"
   *
   * @generated from field: string area_name = 1;
   */
  areaName: string;

  /**
   * カラーコード
   *
   * @generated from field: string color = 2;
   */
  color: string;

  /**
   * 赤成分 (0-255)
   *
   * @generated from field: int32 r = 3;
   */
  r: number;

  /**
   * 緑成分 (0-255)
   *
   * @generated from field: int32 g = 4;
   */
  g: number;

  /**
   * 青成分 (0-255)
   *
   * @generated from field: int32 b = 5;
   */
  b: number;

  /**
   * カスタムエリアから統合（結合）されたポリゴン領域。issue #2224。
   * 色変換・オーバーレイ時、このポリゴンをベースマスクに union して当該ベースエリアの一部として扱う。
   * 空（未設定）の既存パラメータは従来通り「ベースマスク ∩ ¬全カスタムポリゴン」として解釈される（後方互換）。
   *
   * @generated from field: repeated ai_color_simulation.v1.Polygon merged_polygons = 6;
   */
  mergedPolygons: Polygon[];
};

/**
 * Describes the message ai_color_simulation.v1.MainAreaColor.
 * Use `create(MainAreaColorSchema)` to create a new message.
 */
export const MainAreaColorSchema: GenMessage<MainAreaColor> = /*@__PURE__*/
  messageDesc(file_ai_color_simulation_v1_messages, 2);

/**
 * サブエリアの色情報
 *
 * @generated from message ai_color_simulation.v1.SubAreaColor
 */
export type SubAreaColor = Message<"ai_color_simulation.v1.SubAreaColor"> & {
  /**
   * カラーコード
   *
   * @generated from field: string color = 1;
   */
  color: string;

  /**
   * 赤成分 (0-255)
   *
   * @generated from field: int32 r = 2;
   */
  r: number;

  /**
   * 緑成分 (0-255)
   *
   * @generated from field: int32 g = 3;
   */
  g: number;

  /**
   * 青成分 (0-255)
   *
   * @generated from field: int32 b = 4;
   */
  b: number;

  /**
   * 適用するポリゴン領域
   *
   * @generated from field: ai_color_simulation.v1.Polygon polygon = 5;
   */
  polygon?: Polygon;

  /**
   * 結合後の追加ポリゴン領域
   *
   * @generated from field: repeated ai_color_simulation.v1.Polygon polygons = 6;
   */
  polygons: Polygon[];

  /**
   * 検出領域に限定するかどうか（デフォルトtrue: マスク領域とポリゴンの交差範囲のみ色変換）
   *
   * @generated from field: bool use_detected_area_only = 7;
   */
  useDetectedAreaOnly: boolean;

  /**
   * カスタムエリアの表示ラベル
   *
   * @generated from field: string label = 8;
   */
  label: string;
};

/**
 * Describes the message ai_color_simulation.v1.SubAreaColor.
 * Use `create(SubAreaColorSchema)` to create a new message.
 */
export const SubAreaColorSchema: GenMessage<SubAreaColor> = /*@__PURE__*/
  messageDesc(file_ai_color_simulation_v1_messages, 3);

/**
 * 除外エリア情報
 *
 * @generated from message ai_color_simulation.v1.ExcludeArea
 */
export type ExcludeArea = Message<"ai_color_simulation.v1.ExcludeArea"> & {
  /**
   * 除外するポリゴン領域
   *
   * @generated from field: ai_color_simulation.v1.Polygon polygon = 1;
   */
  polygon?: Polygon;
};

/**
 * Describes the message ai_color_simulation.v1.ExcludeArea.
 * Use `create(ExcludeAreaSchema)` to create a new message.
 */
export const ExcludeAreaSchema: GenMessage<ExcludeArea> = /*@__PURE__*/
  messageDesc(file_ai_color_simulation_v1_messages, 4);

/**
 * メインエリアの素材情報（屋根・外壁ベースエリアに素材を適用する場合に使用）
 *
 * @generated from message ai_color_simulation.v1.MainAreaMaterial
 */
export type MainAreaMaterial = Message<"ai_color_simulation.v1.MainAreaMaterial"> & {
  /**
   * "outer wall and balcony" or "roof, ridge"
   *
   * @generated from field: string area_name = 1;
   */
  areaName: string;

  /**
   * 素材マスター（materials テーブル）の ID
   *
   * @generated from field: int64 material_id = 2;
   */
  materialId: bigint;

  /**
   * 素材画像の S3 パス（Python に渡す）
   *
   * @generated from field: string material_image_s3_path = 3;
   */
  materialImageS3Path: string;

  /**
   * 直前回の同一 (area_name, material_id) の素材変換結果画像の S3 パス。
   * セットされている場合 Python 側は Gemini を呼ばずにこの画像を再利用する（コスト削減）。
   *
   * @generated from field: string cached_processed_image_s3_path = 4;
   */
  cachedProcessedImageS3Path: string;

  /**
   * 実例（施工事例）画像の R2 パス（s3://... 形式）。未登録素材は空文字。
   * 空でなければ Python 側は施工事例参照プロンプト（_with_construction）で変換する。
   *
   * @generated from field: string construction_example_image_s3_path = 5;
   */
  constructionExampleImageS3Path: string;

  /**
   * 素材の向き（"" = 未指定 / "horizontal" / "vertical"）。素材マスターから Go が詰める。
   * Python 側はプロンプトに「模様の走る向き」のヒントとして足す（未指定なら足さない）。
   *
   * @generated from field: string orientation = 6;
   */
  orientation: string;

  /**
   * 素材別の生成指示。素材マスターから Go が詰める。
   * Python 側は共通プロンプトテンプレートに**追加**する（置き換えではない）。未設定なら空文字。
   *
   * @generated from field: string prompt = 7;
   */
  prompt: string;
};

/**
 * Describes the message ai_color_simulation.v1.MainAreaMaterial.
 * Use `create(MainAreaMaterialSchema)` to create a new message.
 */
export const MainAreaMaterialSchema: GenMessage<MainAreaMaterial> = /*@__PURE__*/
  messageDesc(file_ai_color_simulation_v1_messages, 5);

/**
 * 素材変換実行結果（次回 ProcessImage 時のキャッシュとして利用される）
 *
 * @generated from message ai_color_simulation.v1.AppliedMainAreaMaterial
 */
export type AppliedMainAreaMaterial = Message<"ai_color_simulation.v1.AppliedMainAreaMaterial"> & {
  /**
   * @generated from field: string area_name = 1;
   */
  areaName: string;

  /**
   * @generated from field: int64 material_id = 2;
   */
  materialId: bigint;

  /**
   * 素材変換済み中間画像の S3 パス
   *
   * @generated from field: string processed_image_s3_path = 3;
   */
  processedImageS3Path: string;

  /**
   * 変換時に使用した施工事例画像の R2 パス（キャッシュ照合用。未使用・旧レコードは空文字）。
   *
   * @generated from field: string construction_example_image_s3_path = 4;
   */
  constructionExampleImageS3Path: string;

  /**
   * 変換時に使用した統合ポリゴン（MainAreaColor.merged_polygons）のハッシュ（issue #2224）。
   * 統合ポリゴンは素材変換のマスク入力を変えるため、キャッシュ照合キーに含める
   * （construction_example_image_s3_path と同じ設計）。Go が保存前に計算して付与し、
   * injectMaterialCachePrefix で照合する。Python はこのフィールドを設定しない。
   * 統合なし・旧レコードは空文字（"" == "" で従来通りヒット = 後方互換）。
   *
   * @generated from field: string merged_polygons_hash = 5;
   */
  mergedPolygonsHash: string;

  /**
   * 変換時に使用した素材マスターの生成設定（向き + 素材別プロンプト）のハッシュ。
   * Admin で向き・素材別プロンプトを変えると生成結果が変わるため、
   * construction_example_image_s3_path と同じ理由でキャッシュ照合キーに含める。
   * Go が保存前に計算して付与し、injectMaterialCachePrefix で照合する。Python は設定しない。
   * 両方未設定・旧レコードは空文字（"" == "" で従来通りヒット = 後方互換）。
   *
   * @generated from field: string material_settings_hash = 6;
   */
  materialSettingsHash: string;
};

/**
 * Describes the message ai_color_simulation.v1.AppliedMainAreaMaterial.
 * Use `create(AppliedMainAreaMaterialSchema)` to create a new message.
 */
export const AppliedMainAreaMaterialSchema: GenMessage<AppliedMainAreaMaterial> = /*@__PURE__*/
  messageDesc(file_ai_color_simulation_v1_messages, 6);

/**
 * 画像色変更処理のリクエスト
 *
 * @generated from message ai_color_simulation.v1.ProcessImageColorRequest
 */
export type ProcessImageColorRequest = Message<"ai_color_simulation.v1.ProcessImageColorRequest"> & {
  /**
   * 画像の入力方法（S3パスまたは直接のバイナリデータ）
   *
   * @generated from oneof ai_color_simulation.v1.ProcessImageColorRequest.payload
   */
  payload: {
    /**
     * S3などのファイルパス go apiで使用
     *
     * @generated from field: string path = 1;
     */
    value: string;
    case: "path";
  } | {
    /**
     * 画像の生データ・ローカルのstorybookで使用
     *
     * @generated from field: bytes raw_image = 2;
     */
    value: Uint8Array;
    case: "rawImage";
  } | { case: undefined; value?: undefined };

  /**
   * ファイル名
   *
   * @generated from field: string image_filename = 3;
   */
  imageFilename: string;

  /**
   * メインエリアの色情報
   *
   * @generated from field: repeated ai_color_simulation.v1.MainAreaColor main_areas = 4;
   */
  mainAreas: MainAreaColor[];

  /**
   * サブエリアの色情報
   *
   * @generated from field: repeated ai_color_simulation.v1.SubAreaColor sub_areas = 5;
   */
  subAreas: SubAreaColor[];

  /**
   * 除外エリア情報
   *
   * @generated from field: repeated ai_color_simulation.v1.ExcludeArea exclude_areas = 6;
   */
  excludeAreas: ExcludeArea[];

  /**
   * キャッシュを無効化して再処理するか
   *
   * @generated from field: bool reprocess = 7;
   */
  reprocess: boolean;

  /**
   * クライアント側の画像幅（imgW）
   *
   * @generated from field: int32 client_width = 8;
   */
  clientWidth: number;

  /**
   * クライアント側の画像高さ（imgH）
   *
   * @generated from field: int32 client_height = 9;
   */
  clientHeight: number;

  /**
   * true の場合、2色展開の外壁や屋根を1色に統一(apply_color_transform_unify)
   *
   * @generated from field: bool unify_two_to_one = 10;
   */
  unifyTwoToOne: boolean;

  /**
   * 案件ID（パス構造に使用）
   *
   * @generated from field: int64 deal_id = 11;
   */
  dealId: bigint;

  /**
   * 外壁マスク済み画像のS3パス (v2)
   *
   * @generated from field: string masked_wall_s3_path = 12;
   */
  maskedWallS3Path: string;

  /**
   * 屋根マスク済み画像のS3パス (v2)
   *
   * @generated from field: string masked_roof_s3_path = 13;
   */
  maskedRoofS3Path: string;

  /**
   * 雨樋マスク済み画像のS3パス (v2)
   *
   * @generated from field: string masked_gutter_s3_path = 14;
   */
  maskedGutterS3Path: string;

  /**
   * 破風・鼻隠しマスク済み画像のS3パス (v2)
   *
   * @generated from field: string masked_fascia_s3_path = 15;
   */
  maskedFasciaS3Path: string;
};

/**
 * Describes the message ai_color_simulation.v1.ProcessImageColorRequest.
 * Use `create(ProcessImageColorRequestSchema)` to create a new message.
 */
export const ProcessImageColorRequestSchema: GenMessage<ProcessImageColorRequest> = /*@__PURE__*/
  messageDesc(file_ai_color_simulation_v1_messages, 7);

/**
 * 画像色変更処理のレスポンス
 *
 * @generated from message ai_color_simulation.v1.ProcessImageColorResponse
 */
export type ProcessImageColorResponse = Message<"ai_color_simulation.v1.ProcessImageColorResponse"> & {
  /**
   * 処理済み画像のファイルのURL
   *
   * @generated from field: string filepath = 1;
   */
  filepath: string;

  /**
   * 処理済み画像のS3パス
   *
   * @generated from field: string s3_path = 2;
   */
  s3Path: string;

  /**
   * @generated from field: int64 deal_id = 4;
   */
  dealId: bigint;

  /**
   * AIカラープロジェクトID(ULID)。deal非依存フローで使用 (issue #1828)
   *
   * @generated from field: string ai_color_project_id = 10;
   */
  aiColorProjectId: string;

  /**
   * フォールバック生成された外壁マスク画像のS3パス (v2)
   *
   * @generated from field: string masked_wall_s3_path = 5;
   */
  maskedWallS3Path: string;

  /**
   * フォールバック生成された屋根マスク画像のS3パス (v2)
   *
   * @generated from field: string masked_roof_s3_path = 6;
   */
  maskedRoofS3Path: string;

  /**
   * フォールバック生成された雨樋マスク画像のS3パス (v2)
   *
   * @generated from field: string masked_gutter_s3_path = 7;
   */
  maskedGutterS3Path: string;

  /**
   * フォールバック生成された破風・鼻隠しマスク画像のS3パス (v2)
   *
   * @generated from field: string masked_fascia_s3_path = 8;
   */
  maskedFasciaS3Path: string;

  /**
   * 今回の素材変換結果（順序通り）。Go 側で永続化し、次回 ProcessImage の cached_processed_image_s3_path 充填に利用する。
   *
   * @generated from field: repeated ai_color_simulation.v1.AppliedMainAreaMaterial applied_main_area_materials = 9;
   */
  appliedMainAreaMaterials: AppliedMainAreaMaterial[];
};

/**
 * Describes the message ai_color_simulation.v1.ProcessImageColorResponse.
 * Use `create(ProcessImageColorResponseSchema)` to create a new message.
 */
export const ProcessImageColorResponseSchema: GenMessage<ProcessImageColorResponse> = /*@__PURE__*/
  messageDesc(file_ai_color_simulation_v1_messages, 8);

/**
 * @generated from message ai_color_simulation.v1.ProcessImageParameters
 */
export type ProcessImageParameters = Message<"ai_color_simulation.v1.ProcessImageParameters"> & {
  /**
   * メインエリアの色情報
   *
   * @generated from field: repeated ai_color_simulation.v1.MainAreaColor main_areas = 1;
   */
  mainAreas: MainAreaColor[];

  /**
   * サブエリアの色情報
   *
   * @generated from field: repeated ai_color_simulation.v1.SubAreaColor sub_areas = 2;
   */
  subAreas: SubAreaColor[];

  /**
   * 除外エリア情報
   *
   * @generated from field: repeated ai_color_simulation.v1.ExcludeArea exclude_areas = 3;
   */
  excludeAreas: ExcludeArea[];

  /**
   * キャッシュを無効化して再処理するか
   *
   * @generated from field: bool reprocess = 4;
   */
  reprocess: boolean;

  /**
   * true の場合、2色展開の外壁や屋根を1色に統一（apply_color_transform_unify）
   *
   * @generated from field: bool unify_two_to_one = 5;
   */
  unifyTwoToOne: boolean;

  /**
   * メインエリアの素材情報（屋根・外壁ベースエリアに素材を適用）
   *
   * @generated from field: repeated ai_color_simulation.v1.MainAreaMaterial main_area_materials = 6;
   */
  mainAreaMaterials: MainAreaMaterial[];
};

/**
 * Describes the message ai_color_simulation.v1.ProcessImageParameters.
 * Use `create(ProcessImageParametersSchema)` to create a new message.
 */
export const ProcessImageParametersSchema: GenMessage<ProcessImageParameters> = /*@__PURE__*/
  messageDesc(file_ai_color_simulation_v1_messages, 9);

/**
 * 画像色変更処理のリクエスト
 *
 * @generated from message ai_color_simulation.v1.ProcessImageRequest
 */
export type ProcessImageRequest = Message<"ai_color_simulation.v1.ProcessImageRequest"> & {
  /**
   * 画像の指定方法（S3パスまたはID）
   *
   * @generated from oneof ai_color_simulation.v1.ProcessImageRequest.image_source
   */
  imageSource: {
    /**
     * 元画像のID（OriginalColorSimulationImagesのID） - Go APIで使用
     *
     * @generated from field: int64 image_id = 1;
     */
    value: bigint;
    case: "imageId";
  } | {
    /**
     * 元画像のS3パス - Python APIで使用
     *
     * @generated from field: string base_image_s3_path = 2;
     */
    value: string;
    case: "baseImageS3Path";
  } | { case: undefined; value?: undefined };

  /**
   * 画像処理のパラメータ
   *
   * @generated from field: ai_color_simulation.v1.ProcessImageParameters parameters = 4;
   */
  parameters?: ProcessImageParameters;

  /**
   * 外壁マスク済み画像のS3パス (v2)
   *
   * @generated from field: optional string masked_wall_s3_path = 6;
   */
  maskedWallS3Path?: string;

  /**
   * 屋根マスク済み画像のS3パス (v2)
   *
   * @generated from field: optional string masked_roof_s3_path = 7;
   */
  maskedRoofS3Path?: string;

  /**
   * 案件ID（結果画像パス構造に使用）
   *
   * @generated from field: int64 deal_id = 8;
   */
  dealId: bigint;

  /**
   * 雨樋マスク済み画像のS3パス (v2)
   *
   * @generated from field: optional string masked_gutter_s3_path = 9;
   */
  maskedGutterS3Path?: string;

  /**
   * 破風・鼻隠しマスク済み画像のS3パス (v2)
   *
   * @generated from field: optional string masked_fascia_s3_path = 10;
   */
  maskedFasciaS3Path?: string;

  /**
   * AIカラープロジェクトID(ULID)。deal非依存フローで使用 (issue #1828)
   *
   * @generated from field: string ai_color_project_id = 11;
   */
  aiColorProjectId: string;
};

/**
 * Describes the message ai_color_simulation.v1.ProcessImageRequest.
 * Use `create(ProcessImageRequestSchema)` to create a new message.
 */
export const ProcessImageRequestSchema: GenMessage<ProcessImageRequest> = /*@__PURE__*/
  messageDesc(file_ai_color_simulation_v1_messages, 10);

/**
 * Pre-warming用のリクエスト
 *
 * @generated from message ai_color_simulation.v1.WarmUpRequest
 */
export type WarmUpRequest = Message<"ai_color_simulation.v1.WarmUpRequest"> & {
};

/**
 * Describes the message ai_color_simulation.v1.WarmUpRequest.
 * Use `create(WarmUpRequestSchema)` to create a new message.
 */
export const WarmUpRequestSchema: GenMessage<WarmUpRequest> = /*@__PURE__*/
  messageDesc(file_ai_color_simulation_v1_messages, 11);

/**
 * Pre-warming用のレスポンス
 *
 * @generated from message ai_color_simulation.v1.WarmUpResponse
 */
export type WarmUpResponse = Message<"ai_color_simulation.v1.WarmUpResponse"> & {
  /**
   * "ready"
   *
   * @generated from field: string status = 1;
   */
  status: string;
};

/**
 * Describes the message ai_color_simulation.v1.WarmUpResponse.
 * Use `create(WarmUpResponseSchema)` to create a new message.
 */
export const WarmUpResponseSchema: GenMessage<WarmUpResponse> = /*@__PURE__*/
  messageDesc(file_ai_color_simulation_v1_messages, 12);

/**
 * @generated from enum ai_color_simulation.v1.ProcessImageType
 */
export enum ProcessImageType {
  /**
   * @generated from enum value: PROCESS_IMAGE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 過去プロジェクト用: グレースケール画像（廃止、非表示用）
   *
   * @generated from enum value: PROCESS_IMAGE_TYPE_CLEANED = 1;
   */
  CLEANED = 1,

  /**
   * @generated from enum value: PROCESS_IMAGE_TYPE_PROCESSED = 2;
   */
  PROCESSED = 2,

  /**
   * v2: 外壁マスク済み画像
   *
   * @generated from enum value: PROCESS_IMAGE_TYPE_MASKED_WALL = 4;
   */
  MASKED_WALL = 4,

  /**
   * v2: 屋根マスク済み画像
   *
   * @generated from enum value: PROCESS_IMAGE_TYPE_MASKED_ROOF = 5;
   */
  MASKED_ROOF = 5,

  /**
   * v2: 雨樋マスク済み画像
   *
   * @generated from enum value: PROCESS_IMAGE_TYPE_MASKED_GUTTER = 6;
   */
  MASKED_GUTTER = 6,

  /**
   * v2: 破風・鼻隠しマスク済み画像
   *
   * @generated from enum value: PROCESS_IMAGE_TYPE_MASKED_FASCIA = 7;
   */
  MASKED_FASCIA = 7,
}

/**
 * Describes the enum ai_color_simulation.v1.ProcessImageType.
 */
export const ProcessImageTypeSchema: GenEnum<ProcessImageType> = /*@__PURE__*/
  enumDesc(file_ai_color_simulation_v1_messages, 0);

